import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    width: '100%',
    padding: theme.spacing(0.5, 1),

    '& .recharts-wrapper *': {
      outline: 'none !important',
    },
  },
}));
